import React from "react";
import CustomTable from "@components/CustomTable";
import { ZERO_VALUE, ONE_VALUE, REDUCE_TIMEOUT, FIRST_INDEX } from "./constants";

/**
 * RecordsTableRenderer component - renders source and destination record tables
 * @param {object} singleAction - The corrective action data
 * @param {number} correctiveActionCount - Total count of corrective actions
 * @param {array} columns - Table column configuration
 * @param {function} translate - Translation function
 */
const RecordsTableRenderer = ({
  singleAction,
  correctiveActionCount,
  columns,
  translate,
  correctiveAction,
}) => {
  const sourceData = [];
  const destinationData = [];

  const record = singleAction;

  if (!!record.SourceRecords.length) {
    record.SourceRecords.forEach((sourceRecord) => {
      sourceData.push(sourceRecord);
    });
  }
  if (!!record.DestinationRecords.length) {
    record.DestinationRecords.forEach((destinationRecord) => {
      destinationData.push(destinationRecord);
    });
  }

  const destinationDataAmount = destinationData.reduce((acc, record) => {
    return acc + record.Amount;
  }, REDUCE_TIMEOUT);

  const sourceDataAmount = sourceData.reduce((acc, record) => {
    return acc + record.Amount;
  }, REDUCE_TIMEOUT);

  return (
    <div className="p-5 pl-10 w-full flex flex-col gap-2">
      {!!destinationData?.length && (
        <CustomTable
          externalData={destinationData}
          columnsWithoutPin={columns}
          loading={false}
          pinCondition={() => false}
          allowRowPinning={false}
          pinningInitialState={[""]}
          setParentSelectedValues={() => {}}
          prefix="ExceptionAtHandRecords"
          title={`${destinationData.length} ${translate(
            "run-matching-records.destination-records"
          )} ${
            destinationDataAmount
              ? ` - ${destinationDataAmount} ${correctiveAction[FIRST_INDEX].Currency}`
              : ""
          }`}
          pinnedRowHeight={62}
          maxTableHeight={400}
          showFilter={false}
          minimalTable={true}
          hideActionColumn={true}
          hidePinColumn={true}
          isExpandable={true}
          initialTableVisibility={correctiveActionCount > ONE_VALUE ? false : true}
        />
      )}
      {!!sourceData?.length && (
        <CustomTable
          externalData={sourceData}
          columnsWithoutPin={columns}
          loading={false}
          pinCondition={() => false}
          allowRowPinning={false}
          pinningInitialState={[""]}
          setParentSelectedValues={() => {}}
          prefix="SourceRecords"
          title={`${sourceData.length} ${translate(
            "run-matching-records.source-records"
          )}${
            sourceData.length > ONE_VALUE ||
            sourceData.length === ZERO_VALUE ||
            !sourceData
              ? "s"
              : ""
          } ${
            sourceDataAmount
              ? ` - ${sourceDataAmount} ${correctiveAction[FIRST_INDEX].Currency}`
              : ""
          }`}
          pinnedRowHeight={62}
          maxTableHeight={400}
          showFilter={false}
          minimalTable={true}
          hidePinColumn={true}
          hideActionColumn={true}
          isExpandable={true}
          initialTableVisibility={correctiveActionCount > ONE_VALUE ? false : true}
        />
      )}
    </div>
  );
};

export default RecordsTableRenderer;
